module.exports = __webpack_public_path__ + "img/tło_piasecki.069f52af.png";